export const allVideos = [
  {
    id: 1,
    title: "Arthritis",
    youtubeUrl: "https://www.youtube.com/watch?v=fAtxcIVFtBQ",
  },
  {
    id: 2,
    title: "Knee Pain",
    youtubeUrl: "https://www.youtube.com/watch?v=qaYmEdsm4Dk",
  },
  {
    id: 3,
    title: "Kneck & Should Pain",
    youtubeUrl: "https://www.youtube.com/watch?v=UmU02zJJZOI",
  },
  {
    id: 4,
    title: "Back Pain",
    youtubeUrl: "https://www.youtube.com/watch?v=ZTPy0Uwh-84",
  },

];

export const clientAssignments = {
  id: "PBG1010461",
  assignedVideoIds: [
    1, 2, 3, 4
  ],
};

